import { CSSProperties } from "react";

export interface IAdUnit {
  plugin: string;
  sid: string;
  keywords?: string;
  subid?: string;
  display?: string;
  responsive?: string;
  isflt?: string;
  style: CSSProperties;
}

export const defaultAdUnit: IAdUnit = {
  plugin: "banner",
  sid: "",
  keywords: "",
  subid: "",
  responsive: "0",
  style: {},
};

export const defaultSkyScrapper: IAdUnit = {
  ...defaultAdUnit,
  style: {
    width: "160px",
    height: "600px"
  }
};

export const defaultAd300x250: IAdUnit = {
  ...defaultAdUnit,
  style: {
    width: "300px",
    height: "250px"
  }
};
